import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { Layers, Modals } from '../stores/layers';
import { Modal } from '../components/Modal';
import { useMap } from '../Map';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const NoLocationModal = observer(() => {
  const { t } = useTranslateFunction(Layers.search);
  const { layers } = useStore();
  const map = useMap();

  return (
    <Modal
      icon="gys-eatdrink-restaurant-pizza"
      headline={t('no_location')}
      content={t('no_location_explanation')}
      className="no-scrollbar"
      abortAction={layers.closeModal}
      abortText={t('button-abort')}
      acceptAction={() => {
        map?._controls.find((control) => control._geolocateButton).trigger();
        layers.closeModal();
      }}
      acceptText={t('button-ok')}
      isOpen={layers.activeModal === Modals.noLocation}
    />
  );
});
